<script lang="typescript">
    export let text: string = "H6/Roboto/Medium/20px";
    export let color = "var(--color-level-7)";
    export let style = "";
</script>

<h1 style="color:{color}; {style}" class="headline6">{text}</h1>

<style>
    /* H1 */

    .headline6 {
        /* Headline 6 */
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 24px;
        /* identical to box height, or 120% */
        letter-spacing: 0.15px;

        pointer-events: none;
    }
</style>
